//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

export enum SELECTED_ITEM {
  FETCH_ITEM_METADATA = 'SELECTED_ITEM/FETCH_ITEM_METADATA',
  RECEIVE_ITEM_METADATA = 'SELECTED_ITEM/RECEIVE_ITEM_METADATA',
  RELOAD_ITEM_METADATA = 'SELECTED_ITEM/RELOAD_ITEM_METADATA',
  RELOADED_ITEM_METADATA = 'SELECTED_ITEM/RELOADED_ITEM_METADATA',
}
